import React from 'react';

/**
 * A 400 m oval seen from above: clay surface, white lane lines, the finish
 * line and a few cones. Decorative, sits behind the hero.
 */
export function FieldLines({
  className = ''
}: {
  className?: string;
}) {
  const lanes = [0, 1, 2, 3, 4, 5, 6];
  return <svg viewBox="0 0 800 800" className={`pointer-events-none ${className}`} fill="none" aria-hidden="true" data-id="element-164" data-mp="rzgjeuztd2f">
      {/* clay surface */}
      <rect x="40" y="170" width="720" height="460" rx="230" stroke="#C8452B" strokeOpacity=".22" strokeWidth="96" data-id="element-165" data-mp="te0oeu666spu" />
      {/* lane lines */}
      <g stroke="#F5F1E8" strokeOpacity=".16" strokeWidth="2" data-id="element-166" data-mp="yclrr2gpxsii">
        {lanes.map(i => {
        const inset = -42 + i * 14;
        return <rect key={i} x={40 + inset} y={170 + inset} width={720 - inset * 2} height={460 - inset * 2} rx={230 - inset} data-id="element-167" data-mp="omsdtut3t1b3" />;
      })}
      </g>
      {/* finish line */}
      <path d="M520 104 V236" stroke="#F5F1E8" strokeOpacity=".35" strokeWidth="6" data-id="element-168" data-mp="25h3kgf57ygq3" />
      {/* infield */}
      <rect x="140" y="270" width="520" height="260" rx="130" fill="#2E7D4F" fillOpacity=".05" data-id="element-169" data-mp="20i91nd794s5z" />
      {/* cones */}
      <g fill="#F2C230" fillOpacity=".35" data-id="element-170" data-mp="2f754mvugbezq">
        <path d="M250 112 l9 16 h-18 z" data-id="element-171" data-mp="2f87zfeuwa1kx" />
        <path d="M330 112 l9 16 h-18 z" data-id="element-172" data-mp="2afn5mdbznohe" />
        <path d="M410 112 l9 16 h-18 z" data-id="element-173" data-mp="2aeluy9yvx407" />
      </g>
    </svg>;
}